// Catálogo de emojis do ChatPage — dados e busca, sem nada de React.
//
// Out/26. O ícone de emoji no rodapé do chat existia desde sempre e não
// abria nada: era um `<Box>` dentro de um Tooltip, sem `onClick`. Quem
// quisesse um emoji tinha que copiar de outro lugar e colar.
//
// POR QUE LISTA PRÓPRIA, e não uma lib:
//
//   - o catálogo completo das libs atuais é BAIXADO DE CDN em tempo de
//     execução. Painel de atendimento que depende de um host de terceiro
//     pra desenhar um botão é painel que quebra sozinho num dia ruim.
//   - a busca delas é em inglês. Aqui quem digita escreve "coracao",
//     "abraco", "polegar" — e a busca abaixo ignora acento, porque
//     ninguém digita "coração" com cedilha no meio do atendimento.
//   - estilo próprio que briga com o tema (Syne + paleta da marca).
//
// O que fica de fora: emoji raro. Esta lista cobre o que se usa em
// conversa comercial; quem precisar de um fora dela ainda pode colar
// direto no campo de texto, que nunca foi restrito.
//
// O emoji é renderizado pela fonte do SISTEMA, então muda de desenho
// entre Windows, Android e iPhone. Aqui isso é certo, não errado: o
// emoji é o CONTEÚDO da mensagem, e tem que ser o mesmo caractere que
// chega no WhatsApp do cliente. (É o oposto do caso de `crm/icons.js`,
// que trocou emoji por SVG justamente porque lá era decoração de
// interface e precisava ser idêntico em toda máquina.)

// As 6 reações rápidas, na ordem em que o WhatsApp mostra. Aparecem no
// primeiro toque da bolha; o resto do catálogo fica a um clique.
export const REACOES_RAPIDAS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

// [emoji, nome em português]. O nome é o que a busca casa — curto de
// propósito, porque é ele que a pessoa digita.
export const CATEGORIAS = [
  {
    id: 'rostos',
    nome: 'Rostos',
    itens: [
      ['😀', 'sorrindo'], ['😃', 'sorriso aberto'], ['😄', 'feliz'],
      ['😁', 'radiante'], ['😆', 'rindo muito'], ['😅', 'riso nervoso'],
      ['🤣', 'rolando de rir'], ['😂', 'chorando de rir'], ['🙂', 'sorriso leve'],
      ['🙃', 'de cabeça pra baixo'], ['😉', 'piscando'], ['😊', 'sorriso tímido'],
      ['😇', 'anjo'], ['🥰', 'apaixonado'], ['😍', 'olhos de coração'],
      ['🤩', 'maravilhado'], ['😘', 'beijo'], ['😗', 'beijinho'],
      ['😋', 'delícia'], ['😛', 'língua de fora'], ['😜', 'piscando língua'],
      ['🤪', 'doidinho'], ['🤑', 'dinheiro'], ['🤗', 'abraço'],
      ['🤭', 'risinho'], ['🤫', 'silêncio'], ['🤔', 'pensando'],
      ['🤨', 'desconfiado'], ['😐', 'neutro'], ['😑', 'sem expressão'],
      ['😶', 'sem palavras'], ['😏', 'safado'], ['😒', 'contrariado'],
      ['🙄', 'revirando os olhos'], ['😬', 'constrangido'], ['😌', 'aliviado'],
      ['😔', 'cabeça baixa'], ['😪', 'sonolento'], ['😴', 'dormindo'],
      ['😷', 'máscara'], ['🤒', 'febre'], ['🤕', 'machucado'],
      ['🤢', 'passando mal'], ['🤧', 'espirrando'], ['🥵', 'calor'],
      ['🥶', 'frio'], ['🥴', 'tonto'], ['😵', 'atordoado'],
      ['🤯', 'explodindo a cabeça'], ['🤠', 'cowboy'], ['🥳', 'festa'],
      ['😎', 'óculos de sol'], ['🤓', 'nerd'], ['🧐', 'monóculo'],
      ['😕', 'confuso'], ['😟', 'preocupado'], ['🙁', 'triste'],
      ['😮', 'surpreso'], ['😯', 'pasmo'], ['😲', 'chocado'],
      ['😳', 'vergonha'], ['🥺', 'suplicando'], ['😦', 'boca aberta'],
      ['😨', 'com medo'], ['😰', 'ansioso'], ['😥', 'decepcionado'],
      ['😢', 'chorando'], ['😭', 'chorando alto'], ['😱', 'grito de medo'],
      ['😖', 'sofrendo'], ['😞', 'desapontado'], ['😓', 'suando frio'],
      ['😩', 'cansado'], ['😫', 'exausto'], ['🥱', 'bocejando'],
      ['😤', 'bufando'], ['😡', 'furioso'], ['😠', 'bravo'],
      ['🤬', 'xingando'], ['😈', 'diabinho'], ['💀', 'caveira'],
      ['💩', 'cocô'], ['🤡', 'palhaço'], ['👻', 'fantasma'],
      ['👽', 'alienígena'], ['🤖', 'robô'], ['🎃', 'abóbora'],
      ['😺', 'gato feliz'], ['😻', 'gato apaixonado'], ['🙀', 'gato assustado'],
    ],
  },
  {
    id: 'gestos',
    nome: 'Gestos',
    itens: [
      ['👍', 'curtir polegar'], ['👎', 'não curtir'], ['👌', 'ok'],
      ['🤌', 'italiano'], ['🤏', 'pouquinho'], ['✌️', 'paz'],
      ['🤞', 'dedos cruzados'], ['🤟', 'te amo'], ['🤘', 'rock'],
      ['🤙', 'me liga'], ['👈', 'aponta esquerda'], ['👉', 'aponta direita'],
      ['👆', 'aponta pra cima'], ['👇', 'aponta pra baixo'], ['☝️', 'atenção dedo'],
      ['✋', 'mão aberta'], ['🖐', 'cinco dedos'], ['👋', 'tchau oi'],
      ['🤝', 'aperto de mão acordo'], ['🙏', 'obrigado por favor'], ['✍️', 'escrevendo'],
      ['🤳', 'selfie'], ['💪', 'força'], ['👏', 'aplausos parabéns'],
      ['🙌', 'mãos pra cima'], ['🤲', 'palmas juntas'], ['🫰', 'dedos dinheiro'],
      ['🧠', 'cérebro'], ['👀', 'olhos olhando'], ['👄', 'boca'],
      ['👂', 'orelha'], ['💅', 'esmalte'], ['🦾', 'braço mecânico'],
      ['🙋', 'levantando a mão'], ['🙅', 'negando não'], ['🙆', 'tudo certo'],
      ['🤦', 'mão na cabeça'], ['🤷', 'sei lá'], ['💁', 'informação'],
      ['🙇', 'reverência desculpa'], ['🤰', 'grávida'], ['👶', 'bebê'],
      ['🧒', 'criança'], ['👨', 'homem'], ['👩', 'mulher'],
      ['👴', 'senhor'], ['👵', 'senhora'], ['👮', 'polícia'],
      ['👷', 'obra operário'], ['💃', 'dançando'], ['🕺', 'dança homem'],
      ['🚶', 'andando'], ['🏃', 'correndo'], ['👨‍💻', 'programador'],
      ['👩‍💻', 'programadora'], ['👨‍🍳', 'cozinheiro'], ['👩‍🍳', 'cozinheira'],
      ['👨‍⚕️', 'médico'], ['👩‍⚕️', 'médica'], ['🧑‍🏫', 'professor'],
      ['👨‍🔧', 'mecânico'], ['🕵️', 'detetive'], ['🦸', 'herói'],
      ['🎅', 'papai noel'], ['🤵', 'noivo'], ['👰', 'noiva'],
    ],
  },
  {
    id: 'coracoes',
    nome: 'Corações',
    itens: [
      ['❤️', 'coração vermelho'], ['🧡', 'coração laranja'], ['💛', 'coração amarelo'],
      ['💚', 'coração verde'], ['💙', 'coração azul'], ['💜', 'coração roxo'],
      ['🖤', 'coração preto'], ['🤍', 'coração branco'], ['🤎', 'coração marrom'],
      ['💔', 'coração partido'], ['❣️', 'exclamação coração'], ['💕', 'dois corações'],
      ['💞', 'corações girando'], ['💓', 'coração batendo'], ['💗', 'coração crescendo'],
      ['💖', 'coração brilhando'], ['💘', 'coração com flecha'], ['💝', 'coração de presente'],
      ['💌', 'carta de amor'], ['💋', 'marca de beijo'], ['🌹', 'rosa'],
      ['💐', 'buquê'], ['💍', 'anel'], ['😽', 'gato beijo'],
    ],
  },
  {
    id: 'natureza',
    nome: 'Natureza',
    itens: [
      ['🐶', 'cachorro'], ['🐱', 'gato'], ['🐭', 'rato'],
      ['🐹', 'hamster'], ['🐰', 'coelho'], ['🦊', 'raposa'],
      ['🐻', 'urso'], ['🐼', 'panda'], ['🐨', 'koala'],
      ['🐯', 'tigre'], ['🦁', 'leão'], ['🐮', 'vaca'],
      ['🐷', 'porco'], ['🐸', 'sapo'], ['🐵', 'macaco'],
      ['🙈', 'macaco sem ver'], ['🙉', 'macaco sem ouvir'], ['🙊', 'macaco sem falar'],
      ['🐔', 'galinha'], ['🐧', 'pinguim'], ['🐦', 'pássaro'],
      ['🐤', 'pintinho'], ['🦆', 'pato'], ['🦅', 'águia'],
      ['🦉', 'coruja'], ['🐺', 'lobo'], ['🐴', 'cavalo'],
      ['🦄', 'unicórnio'], ['🐝', 'abelha'], ['🦋', 'borboleta'],
      ['🐌', 'caracol'], ['🐞', 'joaninha'], ['🐜', 'formiga'],
      ['🕷', 'aranha'], ['🐢', 'tartaruga'], ['🐍', 'cobra'],
      ['🐙', 'polvo'], ['🦐', 'camarão'], ['🦞', 'lagosta'],
      ['🦀', 'caranguejo'], ['🐠', 'peixe tropical'], ['🐟', 'peixe'],
      ['🐬', 'golfinho'], ['🐳', 'baleia'], ['🦈', 'tubarão'],
      ['🐊', 'crocodilo'], ['🦓', 'zebra'], ['🦍', 'gorila'],
      ['🐘', 'elefante'], ['🐪', 'camelo'], ['🦒', 'girafa'],
      ['🐑', 'ovelha'], ['🐐', 'cabra'], ['🦌', 'veado'],
      ['🐓', 'galo'], ['🦃', 'peru'], ['🕊', 'pomba'],
      ['🐾', 'patinhas'], ['🌵', 'cacto'], ['🎄', 'árvore de natal'],
      ['🌲', 'pinheiro'], ['🌳', 'árvore'], ['🌴', 'palmeira'],
      ['🌱', 'muda planta'], ['🌿', 'erva'], ['🍀', 'trevo sorte'],
      ['🍃', 'folhas ao vento'], ['🍂', 'folhas secas'], ['🍁', 'folha de bordo'],
      ['🌾', 'espiga'], ['🌻', 'girassol'], ['🌷', 'tulipa'],
      ['🌼', 'margarida'], ['🌸', 'flor de cerejeira'], ['🌺', 'hibisco'],
      ['☀️', 'sol'], ['🌤', 'sol entre nuvens'], ['⛅', 'parcialmente nublado'],
      ['☁️', 'nuvem'], ['🌧', 'chuva'], ['⛈', 'tempestade'],
      ['❄️', 'floco de neve'], ['⛄', 'boneco de neve'], ['🌪', 'tornado'],
      ['🌈', 'arco íris'], ['💧', 'gota água'], ['🌊', 'onda mar'],
      ['🔥', 'fogo'], ['⭐', 'estrela'], ['🌟', 'estrela brilhando'],
      ['✨', 'brilhos'], ['⚡', 'relâmpago'], ['💥', 'explosão'],
      ['🌙', 'lua'], ['🌍', 'planeta terra'], ['💫', 'estrela cadente'],
    ],
  },
  {
    id: 'comida',
    nome: 'Comida',
    itens: [
      ['🍎', 'maçã'], ['🍐', 'pera'], ['🍊', 'laranja'],
      ['🍋', 'limão'], ['🍌', 'banana'], ['🍉', 'melancia'],
      ['🍇', 'uva'], ['🍓', 'morango'], ['🍈', 'melão'],
      ['🍒', 'cereja'], ['🍑', 'pêssego'], ['🥭', 'manga'],
      ['🍍', 'abacaxi'], ['🥥', 'coco'], ['🥝', 'kiwi'],
      ['🍅', 'tomate'], ['🥑', 'abacate'], ['🍆', 'berinjela'],
      ['🥔', 'batata'], ['🥕', 'cenoura'], ['🌽', 'milho'],
      ['🌶', 'pimenta'], ['🥦', 'brócolis'], ['🥬', 'folhas verdes'],
      ['🧄', 'alho'], ['🧅', 'cebola'], ['🍄', 'cogumelo'],
      ['🥜', 'amendoim'], ['🍞', 'pão'], ['🥐', 'croissant'],
      ['🥖', 'baguete'], ['🧇', 'waffle'], ['🥞', 'panqueca'],
      ['🧀', 'queijo'], ['🍖', 'carne'], ['🍗', 'coxa de frango'],
      ['🥩', 'bife'], ['🥓', 'bacon'], ['🍔', 'hambúrguer'],
      ['🍟', 'batata frita'], ['🍕', 'pizza'], ['🌭', 'hot dog'],
      ['🥪', 'sanduíche'], ['🌮', 'taco'], ['🌯', 'burrito'],
      ['🥙', 'pita wrap'], ['🥚', 'ovo'], ['🍳', 'ovo frito'],
      ['🥘', 'panela'], ['🍲', 'sopa'], ['🥗', 'salada'],
      ['🍿', 'pipoca'], ['🧂', 'sal'], ['🍱', 'marmita'],
      ['🍚', 'arroz'], ['🍛', 'curry'], ['🍜', 'lámen'],
      ['🍝', 'macarrão'], ['🍣', 'sushi'], ['🍤', 'camarão frito'],
      ['🥟', 'guioza'], ['🍦', 'sorvete casquinha'], ['🍨', 'sorvete'],
      ['🍩', 'rosquinha'], ['🍪', 'biscoito'], ['🎂', 'bolo de aniversário'],
      ['🍰', 'fatia de bolo'], ['🧁', 'cupcake'], ['🥧', 'torta'],
      ['🍫', 'chocolate'], ['🍬', 'bala'], ['🍭', 'pirulito'],
      ['🍮', 'pudim'], ['🍯', 'mel'], ['🥛', 'leite'],
      ['☕', 'café'], ['🍵', 'chá'], ['🧉', 'chimarrão'],
      ['🍾', 'champanhe'], ['🍷', 'vinho'], ['🍸', 'drink'],
      ['🍹', 'drink tropical'], ['🍺', 'cerveja'], ['🍻', 'brinde cerveja'],
      ['🥂', 'taça de brinde'], ['🥃', 'whisky'], ['🥤', 'refrigerante'],
      ['🧋', 'bubble tea'], ['🧊', 'gelo'], ['🍼', 'mamadeira'],
    ],
  },
  {
    id: 'atividades',
    nome: 'Atividades',
    itens: [
      ['⚽', 'futebol'], ['🏀', 'basquete'], ['🏈', 'futebol americano'],
      ['⚾', 'beisebol'], ['🎾', 'tênis'], ['🏐', 'vôlei'],
      ['🥏', 'frisbee'], ['🎱', 'sinuca'], ['🏓', 'ping pong'],
      ['🏸', 'badminton'], ['🥊', 'boxe'], ['🥋', 'artes marciais'],
      ['⛳', 'golfe'], ['🎿', 'esqui'], ['🎯', 'alvo'],
      ['🎳', 'boliche'], ['🎮', 'videogame'], ['🎲', 'dado'],
      ['🧩', 'quebra cabeça'], ['♟', 'xadrez'], ['🎭', 'teatro'],
      ['🎨', 'arte pintura'], ['🎤', 'microfone'], ['🎧', 'fone de ouvido'],
      ['🎼', 'partitura'], ['🎹', 'piano'], ['🥁', 'bateria'],
      ['🎸', 'guitarra'], ['🎺', 'trompete'], ['🎻', 'violino'],
      ['🏆', 'troféu'], ['🥇', 'medalha de ouro'], ['🥈', 'medalha de prata'],
      ['🥉', 'medalha de bronze'], ['🏅', 'medalha'], ['🎫', 'ingresso'],
      ['🎪', 'circo'], ['🎉', 'festa comemorar'], ['🎊', 'confete'],
      ['🎈', 'balão'], ['🎁', 'presente'], ['🎀', 'laço'],
      ['🎇', 'fogos'], ['🎆', 'fogos de artifício'],
    ],
  },
  {
    id: 'lugares',
    nome: 'Viagem',
    itens: [
      ['🚗', 'carro'], ['🚕', 'táxi'], ['🚙', 'suv'],
      ['🚌', 'ônibus'], ['🏎', 'carro de corrida'], ['🚓', 'viatura'],
      ['🚑', 'ambulância'], ['🚒', 'bombeiro'], ['🚐', 'van'],
      ['🛻', 'picape'], ['🚚', 'caminhão'], ['🚛', 'carreta'],
      ['🏍', 'moto'], ['🛵', 'scooter entrega'], ['🚲', 'bicicleta'],
      ['🛴', 'patinete'], ['🚦', 'semáforo'], ['🚧', 'obras'],
      ['⛽', 'posto gasolina'], ['🚀', 'foguete'], ['🛸', 'nave'],
      ['🚁', 'helicóptero'], ['✈️', 'avião'], ['🛫', 'decolagem'],
      ['🛬', 'pouso'], ['🚢', 'navio'], ['⛵', 'veleiro'],
      ['⚓', 'âncora'], ['🏠', 'casa'], ['🏡', 'casa com jardim'],
      ['🏢', 'escritório'], ['🏬', 'loja'], ['🏭', 'fábrica'],
      ['🏥', 'hospital'], ['🏦', 'banco'], ['🏨', 'hotel'],
      ['🏪', 'mercado'], ['🏫', 'escola'], ['⛪', 'igreja'],
      ['🏖', 'praia'], ['🏝', 'ilha'], ['🏔', 'montanha'],
      ['🌋', 'vulcão'], ['🗺', 'mapa'], ['🗽', 'estátua da liberdade'],
      ['🎡', 'roda gigante'], ['🎢', 'montanha russa'], ['🌅', 'amanhecer'],
      ['🌃', 'noite'], ['🌇', 'pôr do sol'], ['🌉', 'ponte à noite'],
    ],
  },
  {
    id: 'objetos',
    nome: 'Objetos',
    itens: [
      ['📱', 'celular'], ['📲', 'chamada no celular'], ['💻', 'notebook'],
      ['⌨️', 'teclado'], ['🖥', 'computador'], ['🖨', 'impressora'],
      ['🖱', 'mouse'], ['🎥', 'filmadora'], ['📷', 'câmera foto'],
      ['📸', 'câmera com flash'], ['📹', 'filmando vídeo'], ['📺', 'televisão'],
      ['📻', 'rádio'], ['🎙', 'microfone de estúdio'], ['⏰', 'despertador'],
      ['⏱', 'cronômetro'], ['⌛', 'ampulheta'], ['⏳', 'tempo passando'],
      ['📅', 'calendário'], ['🗓', 'agenda'], ['📈', 'gráfico subindo'],
      ['📉', 'gráfico caindo'], ['📊', 'gráfico de barras'], ['📋', 'prancheta'],
      ['📌', 'alfinete'], ['📍', 'localização'], ['📎', 'clipe anexo'],
      ['📏', 'régua'], ['✂️', 'tesoura'], ['🗃', 'arquivo'],
      ['🗑', 'lixeira'], ['🔒', 'trancado'], ['🔓', 'destrancado'],
      ['🔑', 'chave'], ['🔨', 'martelo'], ['🔧', 'chave inglesa'],
      ['⚙️', 'engrenagem'], ['🧰', 'caixa de ferramentas'], ['💊', 'comprimido'],
      ['💉', 'injeção'], ['🩺', 'estetoscópio'], ['🩹', 'band aid'],
      ['🧪', 'tubo de ensaio'], ['🧬', 'dna'], ['🔬', 'microscópio'],
      ['🔭', 'telescópio'], ['📡', 'antena'], ['💡', 'ideia lâmpada'],
      ['🔋', 'bateria'], ['🔌', 'tomada'], ['🧯', 'extintor'],
      ['🛒', 'carrinho de compras'], ['💰', 'saco de dinheiro'], ['💵', 'dinheiro'],
      ['💳', 'cartão de crédito'], ['🧾', 'recibo nota'], ['💸', 'dinheiro voando'],
      ['✉️', 'envelope'], ['📧', 'email'], ['📨', 'mensagem recebida'],
      ['📤', 'caixa de saída'], ['📥', 'caixa de entrada'], ['📦', 'pacote entrega'],
      ['📫', 'caixa de correio'], ['📰', 'jornal'], ['📝', 'anotação'],
      ['✏️', 'lápis'], ['🖊', 'caneta'], ['🖌', 'pincel'],
      ['📚', 'livros'], ['📖', 'livro aberto'], ['📓', 'caderno'],
      ['📄', 'página documento'], ['🧹', 'vassoura'], ['🧽', 'esponja'],
      ['🚪', 'porta'], ['🛏', 'cama'], ['🛋', 'sofá'],
      ['🚿', 'chuveiro'], ['🛁', 'banheira'], ['🪑', 'cadeira'],
      ['👓', 'óculos'], ['🕶', 'óculos escuros'], ['👔', 'gravata'],
      ['👕', 'camiseta'], ['👖', 'calça jeans'], ['👗', 'vestido'],
      ['🧥', 'jaqueta'], ['🧣', 'cachecol'], ['🧤', 'luvas'],
      ['🧦', 'meias'], ['👟', 'tênis'], ['👠', 'salto alto'],
      ['👢', 'bota'], ['🎩', 'cartola'], ['🧢', 'boné'],
      ['⛑', 'capacete'], ['👑', 'coroa'], ['👜', 'bolsa'],
      ['🎒', 'mochila'], ['💼', 'maleta trabalho'], ['☂️', 'guarda chuva'],
    ],
  },
  {
    id: 'simbolos',
    nome: 'Símbolos',
    itens: [
      ['✅', 'check verde certo'], ['☑️', 'marcado'], ['✔️', 'check'],
      ['❌', 'errado x'], ['⭕', 'círculo'], ['⛔', 'proibido'],
      ['🚫', 'não permitido'], ['💯', 'cem por cento'], ['🔝', 'topo'],
      ['⬆️', 'seta pra cima'], ['⬇️', 'seta pra baixo'], ['⬅️', 'seta pra esquerda'],
      ['➡️', 'seta pra direita'], ['↩️', 'voltar'], ['🔄', 'atualizar'],
      ['🔁', 'repetir'], ['▶️', 'play'], ['⏸', 'pausa'],
      ['⏹', 'parar'], ['⏭', 'próximo'], ['🔊', 'som alto'],
      ['🔇', 'mudo'], ['🔔', 'notificação sino'], ['🔕', 'notificação desligada'],
      ['📢', 'anúncio'], ['📣', 'megafone'], ['❓', 'dúvida interrogação'],
      ['❗', 'atenção exclamação'], ['‼️', 'dupla exclamação'], ['⚠️', 'aviso'],
      ['🔞', 'maiores de idade'], ['♻️', 'reciclagem'], ['⚕️', 'saúde'],
      ['♾️', 'infinito'], ['©️', 'copyright'], ['®️', 'marca registrada'],
      ['™️', 'trademark'], ['0️⃣', 'zero'], ['1️⃣', 'um'],
      ['2️⃣', 'dois'], ['3️⃣', 'três'], ['4️⃣', 'quatro'],
      ['5️⃣', 'cinco'], ['6️⃣', 'seis'], ['7️⃣', 'sete'],
      ['8️⃣', 'oito'], ['9️⃣', 'nove'], ['🔟', 'dez'],
      ['🆓', 'grátis'], ['ℹ️', 'informação'], ['🆕', 'novo'],
      ['🆗', 'ok símbolo'], ['🅿️', 'estacionamento'], ['🆘', 'socorro'],
      ['🆚', 'versus'], ['💠', 'diamante'], ['🔺', 'triângulo vermelho'],
      ['🔷', 'diamante azul'], ['🔴', 'bola vermelha'], ['🟢', 'bola verde'],
      ['🟡', 'bola amarela'], ['🟠', 'bola laranja'], ['🟣', 'bola roxa'],
      ['⚫', 'bola preta'], ['⚪', 'bola branca'], ['🟥', 'quadrado vermelho'],
      ['🟩', 'quadrado verde'], ['🟦', 'quadrado azul'], ['🏁', 'bandeira quadriculada'],
      ['🚩', 'bandeira'], ['🇧🇷', 'brasil bandeira'],
    ],
  },
];

// Chave do localStorage dos recentes. Por usuário NÃO — é por navegador,
// e é só conveniência: perder a lista não custa nada a ninguém.
const CHAVE_RECENTES = 'cetto_emojis_recentes';
export const MAX_RECENTES = 24;

/** Tira acento e caixa, pros dois lados da busca.
 *
 * Ninguém digita "coração" com cedilha no meio de um atendimento, e
 * ninguém deveria precisar. `NFD` separa a letra do acento e o regex
 * joga o acento fora.
 */
function normalizar(texto) {
  return (texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
}

/** Todos os emojis em lista única, achatando as categorias. */
const TODOS = CATEGORIAS.flatMap(cat =>
  cat.itens.map(([emoji, nome]) => ({
    emoji,
    nome,
    // Guardado já normalizado: a busca roda a cada tecla digitada e
    // normalizar ~700 nomes por tecla seria trabalho repetido à toa.
    busca: normalizar(`${nome} ${cat.nome}`),
    categoria: cat.id,
  })),
);

/** Emojis cujo nome (ou categoria) casa com o termo. Termo vazio → []. */
export function buscar(termo) {
  const alvo = normalizar(termo);
  if (!alvo) return [];
  // Começa-com antes de contém: quem digita "ca" quer "café" antes de
  // "abacaxi".
  const comeca = [];
  const contem = [];
  for (const item of TODOS) {
    const pos = item.busca.indexOf(alvo);
    if (pos === 0) comeca.push(item);
    else if (pos > 0) contem.push(item);
  }
  return [...comeca, ...contem];
}

/** Emojis usados por último neste navegador, do mais recente pro menos. */
export function lerRecentes() {
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE_RECENTES) || '[]');
    return Array.isArray(bruto) ? bruto.filter(e => typeof e === 'string') : [];
  } catch {
    // localStorage bloqueado (aba privada, cookies desligados) não pode
    // derrubar o painel — sem recentes, ele só abre numa categoria.
    return [];
  }
}

/** Põe o emoji na frente dos recentes. Devolve a lista nova. */
export function registrarUso(emoji) {
  const atual = lerRecentes().filter(e => e !== emoji);
  const novo = [emoji, ...atual].slice(0, MAX_RECENTES);
  try {
    localStorage.setItem(CHAVE_RECENTES, JSON.stringify(novo));
  } catch {
    // idem: gravar é conveniência.
  }
  return novo;
}
